import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import classnames from 'classnames';
import partial from 'lodash/partial';
import Attribute from 'marketing/common/attribute';
import { trackGoogle } from 'common/tracking';
import { openChat } from 'common/components/drift_chat';

const TEAM = [{
  name: 'Marc B.',
  image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_support_marc.png',
  details: 'Florida',
}, {
  name: 'Jordan K.',
  image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_support_jordan.png',
  details: 'Florida',
}, {
  name: 'Stefanie M.',
  image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_support_stefanie.jpg',
  details: 'Florida',
}, {
  name: 'Ashlee B.',
  image: 'https://assets.crowdspring.com/marketing/crowdspring_marketing_support_ashlee.jpg',
  details: 'Florida',
},
];

var phoneForwarderCallback = (formatted_number, mobile_number) => {
  // formatted_number: number to display, in the same format as
  //        the number passed to _googWcmGet().
  //        (in this case, '1-800-123-4567')
  // mobile_number: number formatted for use in a clickable link
  //        with tel:-URI (in this case, '+18001234567')
  var e = document.getElementById("cs-phone-number");
  e.href = "tel:" + mobile_number;
  var span = e.getElementsByTagName('span')
  span.innerHTML = "";
  span.appendChild(document.createTextNode(formatted_number));

  var e = document.getElementById("cs-mobile-phone-number");
  e.href = "tel:" + mobile_number;
};

class Support extends Component {
  componentDidMount() {
    try {
      if (window._googWcmGet) {
        window._googWcmGet(phoneForwarderCallback, '877.887.7442');
      }
    } catch (e) {
      console.info(e);
    }
  }

  render() {
    const {
      blockClasses, title, leftBlockTitle, leftBlockContent, rightBlockTitle, rightBlockContent,
      consultationLinkLabel='Free design consultation', consultationLink, isCreative
    } = this.props;
    const memberNum = Math.floor(Math.random() * TEAM.length);
    const { name, image, details } = TEAM[memberNum];
    const avatarClass = classnames('avatar avatar-xl avatar-round avatar-team');

    return (
      <section className={classnames('block block-support invert-text', blockClasses)}>
        <div className="row">
          <div className="columns medium-16 large-10">
            <div className="row-columns">
              <div className="block-header">
                <h2 dangerouslySetInnerHTML={{ __html: title || 'Real people, real&nbsp;support.' }} />
              </div>
            </div>
            <div className="row columns">
              <div className="team-member">
                <img src={image} alt="a customer support superhero at crowdspring"
                  className={avatarClass} />
                <div className="team-member-meta">
                  <div className="name">{name}</div>
                  <span className="location">{details}</span>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="columns small-16 medium-8">
                <div className="content-block">
                  <h3>{ leftBlockTitle || 'A team you can rely on.' }</h3>

                  { leftBlockContent?
                  <p dangerouslySetInnerHTML={{ __html: leftBlockContent }} /> :
                  <p>
                    Our award-winning dedicated customer support team has a 99% satisfaction rating,
                    and can help by phone, mail and chat. <br className="show-for-large" />
                  </p> }

                  <div className="content-actions">
                    Questions? <Link to="/help/contact">Just ask.</Link>
                  </div>

                  <div className="content-actions">
                    <ul className="hide-for-small-only">
                      <li>
                      <a href="tel:877.887.7442" id="cs-phone-number" onClick={trackGoogle.bind(null, 'contact', 'clicked phone number', 'support', null, null)} ><i className="fa fa-fw fa-phone" /> <span>877.887.7442</span></a>
                      </li>
                      <li>
                        <Link to="/help/contact/"><i className="fa fa-fw fa-envelope-o" /> Email</Link>
                      </li>
                      { !isCreative &&
                      <li>
                        <a onClick={openChat}>
                          <i className="fa fa-fw fa-comments" /> Chat
                        </a>
                      </li> }
                    </ul>
                    <div className="row hide-for-medium">
                      <p className="small-8 columns">
                        <a href="tel:877.887.7442" id="cs-mobile-phone-number" className="btn btn-secondary btn-block">
                          <i className="fa fa-fw fa-phone" /> <span>Call</span>
                              </a>
                      </p>
                      <p className="small-8 columns">
                        <Link to="/help/contact/" className="btn btn-secondary btn-block">
                          <i className="fa fa-fw fa-envelope-o" /> Email
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="columns small-16 medium-8">
                <div className="content-block">
                  <h3>{ rightBlockTitle || 'Need help deciding?' }</h3>

                  { rightBlockContent?
                  <p dangerouslySetInnerHTML={{ __html: rightBlockContent }} /> :
                  <p>
                    We&#39;re happy only when you are. <br className="show-for-large" />
                    Our support team is always ready to help you with a free, no obligation
                    design consultation.
                  </p> }

                  <div className="content-actions">
                    <Link to={consultationLink || "/help/contact/consultation/"}
                        className="show-for-medium">
                      { consultationLinkLabel } <i className="fa fa-long-arrow-right" />
                    </Link>
                    <Link to={consultationLink || "/help/contact/consultation/"}
                        className="btn btn-secondary btn-block hide-for-medium">
                      { consultationLinkLabel } <i className="fa fa-long-arrow-right" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="columns small-16 medium-8 medium-offset-4 large-6 large-offset-0">
            <img
              src="https://assets.crowdspring.com/marketing/crowdspring_marketing_support-2x.png"
              alt="octopus illustration by lolalovesyou from crowdspring"
              className="support-image"
                  />
            <Attribute to="lolalovesyou" />
          </div>
        </div>
      </section>
    );
  };
};

Support.propTypes = {
  title: PropTypes.string,
  blockClasses: PropTypes.string,
  leftBlockTitle: PropTypes.string,
  leftBlockContent: PropTypes.string,
  rightBlockTitle: PropTypes.string,
  rightBlockContent: PropTypes.string,
  consultationLinkLabel: PropTypes.string,
  consultationLink: PropTypes.string,
};

export default Support;
